export default __webpack_public_path__ + "static/media/logo-white.afad20ce.svg";